export default __webpack_public_path__ + "41eae4975b065815ab13fd9107a28570.png";